module.exports = new __parcel__URL__("bird_select.da89bd18.mp3").toString();